import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import api from "../../constants/api.js";
import "./materia.css";

// 🔥 reutiliza o mesmo carrossel
import Carrossel from "../../componentes/carrossel/carrossel.jsx";

function Materia() {
  const { id_materia } = useParams();

  const [materia, setMateria] = useState(null);
  const [midiasFooter, setMidiasFooter] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    async function fetchDados() {
      try {
        setLoading(true);

        const [materiaRes, midiasRes] = await Promise.all([
          api.get(`/materias/${id_materia}`),
          api.get(`/materias/${id_materia}/midias-footer`) // ✅ rota correta
        ]);

        setMateria(materiaRes.data);
        setMidiasFooter(midiasRes.data || []);
      } catch (err) {
        setError(err.response?.data?.error || "Erro ao buscar matéria");
      } finally {
        setLoading(false);
      }
    }

    fetchDados();
  }, [id_materia]);

  if (loading) return <p>Carregando matéria...</p>;
  if (error) return <p>{error}</p>;
  if (!materia) return <p>Matéria não encontrada</p>;

  function formatarData(data) {
    return new Date(data).toLocaleDateString("pt-BR", {
      day: "2-digit",
      month: "long",
      year: "numeric",
    });
  }

  return (
    <div className="container-materia">
      <div className="materia-unica">
        {materia.imagem_url && (
          <img src={materia.imagem_url} alt={materia.titulo} />
        )}

        <h1>{materia.titulo}</h1>
        <p>{materia.texto}</p>

        {materia.created_at && (
          <div className="materia-data">
            Data de publicação: {formatarData(materia.created_at)}
          </div>
        )}
      </div>

      {/* 🔥 FOOTER COM CARROSSEL */}
      {midiasFooter.length > 0 && (
        <section className="materia-footer-carousel">
          <Carrossel items={midiasFooter} tipo="midia" />
        </section>
      )}
    </div>
  );
}

export default Materia;
